import { DodajPomieszczenieModel } from "./dodajPomieszczenieModel";

export class EdytujPomieszczenieModel extends DodajPomieszczenieModel {
    id: string;
}